//@flow
import React from 'react';
import theme from './EntityDocumentUpload.scss';
import { EntityDocumentUpload } from './';
import { EnhancedInput } from 'common/components/core/input';
import { HelpTooltip } from 'common/components/core/help';
import { SizeEnum } from 'common/enums/UIEnums';
import DateTimePicker from 'common/components/core/form/DateTimePicker';
import FileSizeUtil from 'common/utils/FileSizeUtil';
import Icon from 'common/components/core/icon';
import DateTimeUtils, { CustomDateFormats } from 'common/utils/DateTimeUtils';

type Props = {
    onChangeHandler: Object => void,
    currentDocument: Object,
    t: string => string,
    maxSize: string,
    accept: Array<string>,
    onChange: Object => void
};
export default class EntityDocumentUploadCard extends React.PureComponent<
    Props,
    void
> {
    static defaultProps = {
        maxSize: 10485760, //10 MB file size
        accept: ['.png', '.jpg', '.jpeg', '.doc', '.docx', '.pdf']
    };
    setField = (field: string, value: string) => {
        const { onChangeHandler, currentDocument } = this.props;
        let updatedDocument;
        if (field === 'expiryDate') {
            updatedDocument = currentDocument.setExpiryDate(value);
        } else {
            updatedDocument = currentDocument.setDocumentId(value);
        }
        onChangeHandler(updatedDocument);
    };
    setExpiryDate = (value: string) =>
        // TODO: check what is the type of value
        this.setField(
            'expiryDate',
            value
                ? DateTimeUtils.customFormat(value, CustomDateFormats.API_DATE)
                : value
        );
    setDocumentId = (value: string) => this.setField('documentId', value);
    getExpiryField = () => {
        const { t, currentDocument } = this.props;
        const { expiryDate, isMandatory } = currentDocument;
        return (
            <div className={theme.container}>
                <div className={theme.title}>
                    {t('documentUpload.validUntil')}
                    {isMandatory ? '*' : null}
                    <HelpTooltip
                        tooltipText={t('documentUpload.validUntilTooltip')}
                    />
                </div>
                <DateTimePicker
                    shouldTriggerOnChangeForDateTimeOutsideRange
                    onChange={this.setExpiryDate}
                    showTime={false}
                    fullWidth
                    size={SizeEnum.Small}
                    defaultLevel="years"
                    value={expiryDate}
                    theme={theme}
                    error={currentDocument.getValidationMessage('expiryDate')}
                >
                    <Icon icon="calendar" />
                </DateTimePicker>
            </div>
        );
    };
    getDocumentIdField = () => {
        const { t, currentDocument } = this.props;
        const { isMandatory, documentId, type } = currentDocument;
        return (
            <div className={theme.container}>
                <div className={theme.title}>
                    {type} {t('documentUpload.documentId')}
                    {isMandatory ? '*' : null}
                    <HelpTooltip
                        tooltipText={t('documentUpload.documentIdTooltip')}
                    />
                </div>
                <EnhancedInput
                    value={documentId}
                    onChange={this.setDocumentId}
                    error={currentDocument.getValidationMessage('documentId')}
                />
            </div>
        );
    };
    getTitle = () => {
        const { currentDocument } = this.props;
        const { type, isMandatory } = currentDocument;
        if (type === 'logo') {
            return;
        } else {
            return (
                <div className={theme.documentType}>
                    {type}
                    {isMandatory ? '*' : null}
                </div>
            );
        }
    };
    getDocIdExpContainer = () => {
        const { currentDocument } = this.props;
        const {
            isDocumentIdApplicable,
            isExpiryDateApplicable
        } = currentDocument;
        if (isDocumentIdApplicable || isExpiryDateApplicable) {
            return (
                <div className={theme.docIdExpContainer}>
                    {isDocumentIdApplicable ? this.getDocumentIdField() : null}
                    {isExpiryDateApplicable ? this.getExpiryField() : null}
                </div>
            );
        } else {
            return null;
        }
    };
    render() {
        const {
            currentDocument,
            t,
            maxSize,
            accept,
            onChange,
            onChangeHandler
        } = this.props;
        const maxSizeText = FileSizeUtil.formatBytes(maxSize);
        return (
            <div className={theme.uploadCardWrap}>
                {this.getTitle()}
                <EntityDocumentUpload
                    accept={accept}
                    currentDocument={currentDocument}
                    maxSize={maxSize}
                    maxSizeText={maxSizeText}
                    onChange={onChange}
                    onChangeHandler={onChangeHandler}
                    t={t}
                    theme={theme}
                />
                <div className={theme.formatSizeWrap}>
                    <span>
                        {t('documentUpload.formats')} - {accept.join('/ ')}
                    </span>
                    <span> | </span>
                    <span>
                        {t('documentUpload.maxSize')} - {maxSizeText}
                    </span>
                </div>
                {this.getDocIdExpContainer()}
            </div>
        );
    }
}
